import { useParams } from "next/navigation";
import { resolveKey } from "utils/getTranslation";

export function useTranslation() {
  const params = useParams();
  const locale = (params.locale as string) || "en";
  return (key: string) => resolveKey(locale, key);
}
